<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="p1h7">
<p class="centerImage"><img alt="images" id="img14" src="images/img14.jpg"/></p>
<p class="caption">Trumpeter George Lutz, of Troop C, Fifth Cavalry, ca. 1876. Lutz posed wearing his musicians uniform and holding his sword. His pistol and dress helmet sit on the stand next to him. <em class="italic">Editor’s collection</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_p17.vue?106cbbf6